"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const utils_1 = require("../utils");
const ActionTypes = require("../../../actionTypes/vektorio/detachFolders");
const status_1 = require("../../../status");
const states = (0, utils_1.createRequestStatus)(status_1.RequestType.FETCH);
exports.initialState = {
    status: states.standby(),
    isModalOpen: false
};
const detachFoldersStatusLens = monocle.Lens.fromProp('status');
const isModalOpenLens = monocle.Lens.fromProp('isModalOpen');
const methods = {};
exports.methods = methods;
methods[ActionTypes.DETACH_REQUEST] = (state) => detachFoldersStatusLens.set(status_1.RequestStatusFactory.fetch.busy())(state);
methods[ActionTypes.DETACH_SUCCESS] = (state) => detachFoldersStatusLens.set(status_1.RequestStatusFactory.fetch.success())(state);
methods[ActionTypes.DETACH_FAILURE] = (state) => detachFoldersStatusLens.set(status_1.RequestStatusFactory.fetch.failure())(state);
methods[ActionTypes.TOGGLE_MODAL] = (state) => isModalOpenLens.modify((status) => !status)(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=index.js.map